const getAppleRedirectURI = () => `https://${window.location.host}`;

export default getAppleRedirectURI;
